/* eslint-disable no-case-declarations */
import { GroupingOptions } from '@vae/server/src/modules/consumptionDataGrouper'
import dayjs from 'dayjs'

interface GetLabelsInput {
	from: string | undefined
	grouping: GroupingOptions
	language: 'fi' | 'en'
}
const getLabels = (input: GetLabelsInput): string[] => {
	const { from } = input
	const labels: string[] = []

	const daysInMonth = from ? dayjs(from).daysInMonth() : dayjs().daysInMonth()

	const daysOfWeek = {
		en: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
		fi: ['Maanantai', 'Tiistai', 'Keskiviikko', 'Torstai', 'Perjantai', 'Lauantai', 'Sunnuntai'],
	}

	const monthsOfYear = {
		en: [
			'January',
			'February',
			'March',
			'April',
			'May',
			'June',
			'July',
			'August',
			'September',
			'October',
			'November',
			'December',
		],
		fi: [
			'Tammikuu',
			'Helmikuu',
			'Maaliskuu',
			'Huhtikuu',
			'Toukokuu',
			'Kesäkuu',
			'Heinäkuu',
			'Elokuu',
			'Syyskuu',
			'Lokakuu',
			'Marraskuu',
			'Joulukuu',
		],
	}

	const now = dayjs()
	const fromDate = from ? dayjs(from) : now

	switch (input.grouping) {
		case 'day':
			const currentHour = 23
			for (let i = 0; i <= currentHour; i++) {
				labels.push(`${i}:00`)
			}
			break
		case 'week':
			const currentDayOfWeek = now.isSame(fromDate, 'week') ? now.day() : 7
			for (let i = 0; i < currentDayOfWeek; i++) {
				labels.push(daysOfWeek[input.language][i])
			}
			break
		case 'month':
			const currentDayOfMonth = now.isSame(fromDate, 'month') ? now.date() : daysInMonth
			for (let i = 1; i <= currentDayOfMonth; i++) {
				labels.push(`${i}`)
			}
			break
		case 'year':
			const currentMonth = now.isSame(fromDate, 'year') ? now.month() : 11
			for (let i = 0; i <= currentMonth; i++) {
				labels.push(monthsOfYear[input.language][i])
			}
			break
		default:
			const defaultHour = now.isSame(fromDate, 'day') ? now.hour() : 23
			for (let i = 0; i <= defaultHour; i++) {
				labels.push(`${i}:00`)
			}
	}
	return labels
}

export default getLabels
